<label class="label">Scheduled changes</label>
<div class="scheduled-changes-list-wrapper">
  <div class="header">
    <span class="product">Product</span>
    <span class="price" *ngIf="this.type == 'price'">PriceListCategory</span>
    <div class="header-user-date-container">
      <span class="user">User</span>
      <span class="date">Date</span>
    </div>
  </div>
  <div class="list">
    <ng-container *ngFor="let listItem of listItems">
      <div class="list-item">
        <span class="product">{{listItem.product}}</span>
        <span class="price" *ngIf="listItem.priceListCategory">{{listItem.priceListCategory}}</span>
        <div class="list-item-user-date-delete-container">
          <span class="user">{{listItem.user}}</span>
          <span class="dateAndDelete">
            <span>{{listItem.date}}</span>
            <co-image key="delete" width="16px" height="16px" (click)="onConfirmRemoveScheduledChangeClick({id: listItem.id, product: listItem.product})"></co-image>
          </span>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<message-box (okClick)="onPerformRemoveScheduledChangeClick($event)" [title]="strings.Confirm" [okButtonText]="strings.Yes" [cancelButtonText]="strings.No"></message-box>